<template>
  <scroll-right-frame>
    <div class="whaty-dashboard">
      <el-row class="db-row">
        <el-col :span="24">
          <div class="db-header">
            <i class="mng icon-bars-stroke"></i>
            数据看板
          </div>
        </el-col>
      </el-row>

      <div class="db-row db-stat-row clearfix">
        <div class="db-stat-col">
          <el-card class="db-stat-card blue-card" shadow="hover">
            <div>
              <div class="db-stat-sub-tit">学生数</div>
              <div class="db-stat-sub-num">
                <count-to :end="statData.stuNum"></count-to>
              </div>
            </div>
          </el-card>
        </div>
        <div class="db-stat-col">
          <el-card class="db-stat-card yellow-card" shadow="hover">
            <div>
              <div class="db-stat-sub-tit">教师数</div>
              <div class="db-stat-sub-num">
                <count-to :end="statData.teaNum"></count-to>
              </div>
            </div>
          </el-card>
        </div>
        <div class="db-stat-col">
          <el-card class="db-stat-card green-card" shadow="hover">
            <div>
              <div class="db-stat-sub-tit">课程数</div>
              <div class="db-stat-sub-num">
                <count-to :end="statData.courseNum"></count-to>
              </div>
            </div>
          </el-card>
        </div>
      </div>

      <div class="db-row db-chart-row clearfix">
        <div class="db-chart-col">
          <el-card class="db-chart-card" shadow="hover">
            <div slot="header" class="db-card-header">
              <i class="mng icon-data-bars-fill"></i>
              图表示例1
            </div>
            <whaty-chart :chartCode="'demo-dashboard-chart1'"></whaty-chart>
          </el-card>
        </div>
        <div class="db-chart-col">
          <el-card class="db-chart-card" shadow="hover">
            <div slot="header" class="db-card-header">
              <i class="mng icon-data-bars-fill"></i>
              图表示例2
            </div>
            <whaty-chart :chartCode="'demo-dashboard-chart2'"></whaty-chart>
          </el-card>
        </div>
      </div>

      <div class="db-row db-chart-row clearfix">
        <div class="db-chart-col">
          <el-card class="db-chart-card" shadow="hover">
            <div slot="header" class="db-card-header">
              <i class="mng icon-data-bars-fill"></i>
              图表示例3
            </div>
            <whaty-chart :chartCode="'demo-dashboard-chart3'"></whaty-chart>
          </el-card>
        </div>
        <div class="db-chart-col">
          <el-card class="db-chart-card" shadow="hover">
            <div slot="header" class="db-card-header">
              <i class="mng icon-data-bars-fill"></i>
              图表示例4
            </div>
            <whaty-chart :chartCode="'demo-dashboard-chart4'"></whaty-chart>
          </el-card>
        </div>
      </div>

    </div>
  </scroll-right-frame>
</template>
<script>
  import ScrollRightFrame from '../scroll-right-frame'
  import WhatyChart from '../whaty-charts/whaty-chart'
  import CountTo from '../count-to/count-to'

  export default {
    name: 'dashboard1',
    components: {CountTo, WhatyChart, ScrollRightFrame},
    data() {
      return {
        statData: {
          stuNum: 0,
          teaNum: 0,
          courseNum: 0
        }
      }
    },
    mounted() {
      this.statData = {
        stuNum: 258384,
        teaNum: 961,
        courseNum: 1041
      }
    }
  }
</script>
<style lang="scss">
  .whaty-dashboard {
    padding: 10px;
    min-width: 800px;
    .db-row {
      margin-bottom: 20px;
    }
    .db-header {
      padding-left: 6px;
      font-size: 18px;
      height: 30px;
      line-height: 30px;
      font-weight: bold;
      border-bottom: 1px solid #fbc0bb;
    }

    .db-card-header {
      font-weight: bold;
    }

    .db-stat-row {
      margin-left: -10px;
      margin-right: -10px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
    .db-stat-col {
      padding-left: 10px;
      padding-right: 10px;
      float: left;
      width: 33.3333%;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
    .db-stat-card {
      height: 120px;
      color: #ffffff;
      .db-stat-sub-tit {
        font-size: 14px;
      }
      .db-stat-sub-num {
        font-size: 40px;
        font-weight: bold;
        height: 60px;
        line-height: 60px;
      }
    }

    .db-chart-row {
      margin-left: -10px;
      margin-right: -10px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
    .db-chart-col {
      padding-left: 10px;
      padding-right: 10px;
      float: left;
      width: 50%;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
    .db-chart-card {
      height: 320px;
      .el-card__header {
        padding: 12px 20px;
      }
      .el-card__body {
        padding: 20px 10px 2px 10px;
        height: 252px;
        .whaty-chart-wrapper {
          height: 100%;
          margin: 0;
        }
      }
    }

    .el-card {
      border-color: #dddddd;
    }

    .blue-card {
      background-color: #409EFF;
    }
    .yellow-card {
      background-color: #E6A23C;
    }
    .green-card {
      background-color: #67C23A;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard.vue